import { triadSuperFetch } from 'utils/superFetch';
import { createThrottledQueue } from 'utils/createThrottledQueue';
import { TRIAD_PROXY_ROUTE } from 'app-requests/apiConstants';
import isBrowser from 'utils/isBrowser';
import {
  GA_EVENTS_MAP,
  GA_TO_TMS_EVENT_MAP,
  TMS_EVENT_TYPES,
} from './EVENT_TYPES';

const throttledLogEvent = createThrottledQueue(
  async (eventName: TMS_EVENT_TYPES, eventData: Record<string, string>[]) => {
    await triadSuperFetch(`${TRIAD_PROXY_ROUTE}/logevent`, {
      method: 'POST',
      timeout: 2000,
      body: {
        eventName,
        eventData: Object.keys(eventData).map((key) => ({
          name: key,
          value: eventData[key as keyof typeof eventData],
        })),
      },
    });
  },
  400
);

export function logTmsEvent(
  eventName: TMS_EVENT_TYPES,
  eventData: Record<string, string>[] = []
): void {
  if (isBrowser()) {
    throttledLogEvent(eventName, eventData);
  }
}

export function logTGEventAsTmsEvent(
  eventName: GA_EVENTS_MAP,
  eventData: Record<string, string>[] = []
): void {
  if (!GA_TO_TMS_EVENT_MAP[eventName]) {
    return;
  }
  try {
    throttledLogEvent(GA_TO_TMS_EVENT_MAP[eventName], eventData);
  } catch {
    // don't report
  }
}
